import { PropertyType } from '../../../common';

export const mapEntityToApi = (data: PropertyType): PropertyType => ({
	sid: data.token,
	player_id: data.playerId,
});
